import { useEffect } from 'react';
import { useLinkPreviewStore } from '../../../stores/linkPreviewStore';

export function useCanvasLinkIndicatorListener(): void {
  // Listen for link indicator clicks
  useEffect(() => {
    const handleLinkClick = (e: CustomEvent<{ nodeId: string; linkedDiagramId: string; linkId: string }>) => {
      const { linkedDiagramId } = e.detail;
      useLinkPreviewStore.getState().open(linkedDiagramId);
    };

    window.addEventListener('canvas:link:click', handleLinkClick as EventListener);
    return () => {
      window.removeEventListener('canvas:link:click', handleLinkClick as EventListener);
    };
  }, []);
}

